import { Component, Input } from '@angular/core';
import { isNumericDynamicColumn } from 'src/app/shared/helpers/dynamic-data-table.util';

@Component({
  selector: 'app-dynamic-data-table',
  templateUrl: './dynamic-data-table.component.html',
  styleUrls: ['./dynamic-data-table.component.scss'],
})
export class DynamicDataTableComponent {
  @Input() headers: string[] = [];
  @Input() rows: string[][] = [];
  @Input() isDarkMode = false;
  @Input() editable = false;
  @Input() isEditing = false;

  isNumericColumn(columnIndex: number): boolean {
    return isNumericDynamicColumn(this.rows, columnIndex);
  }

  trackHeader(_index: number, header: string): string {
    return header;
  }

  trackRow(index: number): number {
    return index;
  }
}
